// File: src/App.jsx
import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import CategoryPage from "./pages/CategoryPage";
import CartPage from "./pages/CartPage";
import CustomerPage from "./pages/CustomerPage";
import GoldRatePage from "./pages/GoldRatePage";
import ProductPage from "./pages/ProductPage";
import VendorPage from "./pages/VendorPage";
import OrderItemPage from "./pages/OrderItemPage";
import OrderPage from "./pages/OrderPage";
import ProductImagePage from "./pages/ProductImagePage";
import Home from "./components/user/Home";
import About from "./components/user/AboutPage";
import ShoppingCart from "./components/user/ShoppingCart";
import Products from "./components/user/Products/Products";
import Login from "./components/user/Auth/Login";
import ContactUs from "./components/user/ContactUs";
import CheckOut from "./components/CheckOut";
import OrderConfirmation from "./components/user/OrderConfirmation";
import ProductDetails from "./components/user/Products/ProductDetails";
import ProductsGrid from "./components/user/Products/ProductsGrid";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import AdminLogin from "./components/admin/Auth/AdminLogin";
import ProtectedRoute from "./components/admin/Auth/ProtectedRoute";
import Profile from "./components/user/Profile";
import { useSelector } from "react-redux";
import MyOrder from "./components/user/MyOrder";
import OrderManagement from "./components/admin/OrderManagement";
import Wishlist from "./components/user/Wishlist";
import TopNavBar from "./components/admin/TopNavBar";
import ForgotPassword from "./components/user/Auth/ForgotPassword";
import OrderConfirmed from "./components/user/OrderConfirmed";

export function formatINR(value) {
  const num = Number(String(value).replace(/[^\d.-]/g, ""));
  if (Number.isNaN(num)) return value;
  return "₹ " + num.toLocaleString("en-IN") + ".00";
}

export const formatDate = (dateStr) => {
  const d = new Date(dateStr);
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  return `${day}-${month}-${year}`;
};
// function Home() {
//   return (
//     <div className="App">
//       <Header />
//       <MobileHeader />
//       <Slider />
//       <Banners />
//       <ProductList title="Deal of the day" />
//       <TabsSection />
//       <Footer />
//     </div>
//   );
// }

function App() {
  const authUser = useSelector((state) => state.auth.authUser);  
  const [logged, setLogged] = useState(() => {
    return localStorage.getItem("isLoggedIn") === "true";
  });

  const handleLogin = () => {
    setLogged(true);
    localStorage.setItem("isLoggedIn", "true");
  };

  const handleLogout = () => {
    setLogged(false);
    localStorage.removeItem("isLoggedIn");
  };
  return (
    <Router>
      <Routes>
        {/* User routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<Home />} />
        <Route path="/categories" element={<ProductsGrid />} />
        <Route path="/products" element={<Products />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/shopping-cart" element={<ShoppingCart />} />
        <Route path="/wishlist" element={<Wishlist />} />
        <Route path="/check-out" element={<CheckOut />} />
        <Route path="/order-confirm/:orderId" element={<OrderConfirmation />} />
        <Route path="/my-orders" element={<MyOrder />} />
        <Route path="/orders/:orderId/:itemId" element={<OrderConfirmed />} />
        <Route path="/profile" element={<Profile authUser={authUser} />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/:id" element={<ProductDetails />} />

        {/* Admin routes */}

        <Route
          path="/admin/login"
          element={<AdminLogin onLogin={handleLogin} />}
        />
        {/* <Route
        path="/admin/dashboard"
          element={
            <ProtectedRoute isLoggedIn={logged}>
              <TopNavBar onLogout={handleLogout} />
            </ProtectedRoute>
          }
        /> */}
        <Route
          path="/admin/dashboard"
          element={
            <ProtectedRoute isLoggedIn={logged}>
              <Dashboard onLogout={handleLogout} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/category"
          element={
            <ProtectedRoute isLoggedIn={logged}>
              <CategoryPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/cart"
          element={
            <ProtectedRoute isLoggedIn={logged}>
              <CartPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/customer"
          element={
            <ProtectedRoute isLoggedIn={logged}>
              <CustomerPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/gold-rate"
          element={
            <ProtectedRoute isLoggedIn={logged}>
              <GoldRatePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/product"
          element={
            <ProtectedRoute isLoggedIn={logged}>
              <ProductPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/productImage"
          element={
            <ProtectedRoute isLoggedIn={logged}>
              <ProductImagePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/order-items"
          element={
            <ProtectedRoute isLoggedIn={logged}>
              <OrderItemPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/order"
          element={
            <ProtectedRoute isLoggedIn={logged}>
              <OrderPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/order-management"
          element={
            <ProtectedRoute isLoggedIn={logged}>
              <OrderManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/vendor"
          element={
            <ProtectedRoute isLoggedIn={logged}>
              <VendorPage />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
